/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { CSSObjectWithLabel } from '@atlaskit/react-select';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { media } from '@atlassian/bitkit-responsive';

import { overflowEllipsis } from 'src/styles/mixins';

export const PLACEHOLDER_COLOR = colors.N400;

export type StateProps = {
  isFocused: boolean;
};

export const subtleSelector = (css: CSSObjectWithLabel, state: StateProps) => ({
  backgroundColor: state.isFocused ? css.backgroundColor : 'transparent',
  borderColor: state.isFocused ? css.borderColor : 'transparent',
});

export const nothingSelectedColor = () => ({
  color: token('color.text.subtle'),
});

export const FilterGroup = styled.div(
  {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    /* Atlaskit overrides to fit our filter styles */
    '> button': {
      height: '40px',
    },
    '> * + *': {
      margin: `0 ${token('space.050')}`,
    },
    '> :last-child': {
      marginRight: 0,
    },
  },
  media.upToMedium(`
    justify-content: flex-start;

    > * + * {
      margin: ${token('space.100')};
    }
  `),
  media.upToSmall(`
    > * + * {
      margin: ${token('space.100')} 0;
    }
  `)
);

export const BranchSelectorWrapper = styled.div(
  {
    margin: `0 ${token('space.100')} 0 ${token('space.200')}`,
  },
  media.upToMedium(`
    margin: ${token('space.100')} ${token('space.100')} ${token('space.100')} 0;
  `)
);

export const SortSelectorWrapper = styled.div({
  marginLeft: 'auto',
  minWidth: '192px',
});

export const Filter = styled.div<{
  mobileOrder?: number;
  isFirstFilterElement?: boolean;
}>`
  margin-left: ${({ isFirstFilterElement }) =>
    isFirstFilterElement ? token('space.200') : token('space.050')};

  ${media.upToMedium(`
    margin-left: 0;
  `)}

  ${media.upToSmall(`
    order: ${({ mobileOrder }: { mobileOrder?: number }) => mobileOrder || 1};
  `)}
`;

export const Ellipsis = styled.div(overflowEllipsis('100%'));
